import { Component, OnInit, Input } from '@angular/core';
import { AppService } from '../../services/app.service';
import { PageService } from '../../services/page.service';
import { MultiLangPipe } from '../../pipes/multi-lang.pipe';
import { AssetTypePipe } from 'src/app/pipes/asset-type.pipe';

@Component({
  selector: 'app-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.scss']
})
export class ImageComponent implements OnInit {

  @Input() public config: {
    image?: string | Array<any>,
    alt?: string,
    source?: number,
    scale?: number,
    width?: number,
    height?: number,
    align?: string,
    mapping?: {
      imageKey: string | Array<any>
    }
  };

  @Input() public data: { customGetAPI?: Object | string, entityInformation?: Object | string };
  source;
  alt: string = '';
  style = {};
  wrapperStyle = {};
  mappingSource: any;

  constructor(
    public appService: AppService,
    public pageService: PageService,
    public multiLangPipe: MultiLangPipe,
    public assetTypePipe: AssetTypePipe
  ) { }

  /**
   * Image Component
   * @author Lalitkumar Saindane
   * @task QLIKTAG-3314
   */
  ngOnInit() {
    this.style = this.getStyle();
    this.wrapperStyle = this.getWrapperStyle();
    let currentLang: string;

    currentLang = this.pageService.appLang$.getValue();

    if (this.config) {
      if (this.config.hasOwnProperty('source') && this.config.source) {
        this.mappingSource = this.config['source'] === 2 ? this.data['entityInformation'] : null;
      }

      if (this.config.hasOwnProperty('image')) {

        if (Array.isArray(this.config.image) && this.config.image.length > 0) {
          if (this.appService.isMultiLangArray(this.config.image)) {
            let imageLink = this.multiLangPipe.transform(this.config.image, currentLang);
            this.source = imageLink;
          }
        } else {
          if (typeof this.config.image === 'string' && this.config.image) {
            this.source = this.config.image;
          }
        }
      }

      if (this.config.hasOwnProperty('mapping') && this.config.mapping.hasOwnProperty('imageKey')) {

        if (typeof this.config.mapping.imageKey === 'string') {
          const path = this.config.mapping.imageKey.split('.');
          const image = this.appService.findObjectByPath(this.mappingSource, path);
          if (this.appService.isAssetType(image)) {
            const imageLink = this.assetTypePipe.transform(image);
            this.source = imageLink;
          } else if (Array.isArray(image) && image.length > 0) {
            if (this.appService.isMultiLangArray(image)) {
              const imageLink = this.multiLangPipe.transform(image, currentLang);
              this.source = imageLink;
            }
          } else {
            this.source = image;
          }
        }
      }

      if (this.config.hasOwnProperty('alt') && this.config.alt) {
        this.alt = this.config.alt;
      }

    }
  }


  /**
   * set style to ion-img tag
   * @author Lalitkumar Saindane
   * @return [style object]
   * @task QLIKTAG-3314
   */
  getStyle() {
    let properties = {
      "align-self": 'center'
    };

    if (this.config) {
      properties['width'] = `auto`;
      properties['height'] = `auto`;
      if (this.config.hasOwnProperty('width') && this.config.width) {
        properties['width'] = `${this.config.width}px`;
      }

      if (this.config.hasOwnProperty('height') && this.config.height) {
        properties['height'] = `${this.config.height}px`;
      }

      if (this.config.hasOwnProperty('scale') && this.config.scale) {
        properties['max-width'] = `${this.config.scale}%`;
      } else {
        properties['max-width'] = '100%';
      }

    }
    return properties;
  }

  /**
   * get image wrapper style for alignment
   * @author Neil C
   * @return [style object]
   * @task QLIKTAG-3314
   */
  getWrapperStyle() {
    let properties = {
      "display": 'block'
    };

    if (this.config) {

      if (this.config.hasOwnProperty('align')) {
        properties['display'] = "flex";
        properties['justify-content'] = this.config.align ? this.config.align : 'flex-start';
      }

    }
    //console.log('getWrapperStyle', properties);
    return properties;
  }

}
